exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/welcome-page/welcome-page.scss
// module id = ../../../../../src/app/sample/containers/welcome-page/welcome-page.scss
// module chunks = main